import React from "react";
import styles from "./PodViewer.module.css";

const PodViewer = ({ images, signature }) => {
  const allUrls = [...new Set([...images, signature].filter(Boolean))];

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageGrid}>
        {allUrls.map((url, i) => (
          <a
            key={i}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.imageLink}
          >
            <img
              src={url}
              alt={`Proof of delivery ${i + 1}`}
              className={styles.image}
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default PodViewer;
